import PermissionType from '@/userManagement/PermissionType';

export default class CheckUtil {
  // eslint-disable-next-line
   public static checkPer(r: any, permission: PermissionType): boolean {
    if (r.permissions) {
      return !!r.permissions.find((per: any) => per.code === permission.code);
    }
    return false;
  }
  // eslint-disable-next-line
   public checkPagePer(r: any): boolean {
    if (r.permissions) {
      return !!r.permissions.find((per: any) => per.code);
    }
    return false;
  }
}
